(() => {
  'use strict';
  const eligible = new Set([15839880184182,15839882019190,15529973154166,15839882215798,15840417972598,15565632078198,15565633749366,15840417939830,15840418038134,15840418070902,15840524271990,15840524337526,15840525222262,15840525287798,15840985416054,15840985481590,15840987218294,15840987283830,15840987316598,15567604482422,15565636370806,15565637976438,15567603761526,15567603990902,15567604089206,15567604187510,15567604220278,15567604416886,15567604449654,15565634044278,15567604515190,15569610801526,15933279994230,15960315658614,15972209688950,15906190557558]);
  const variants = [{"id":59222682861942,"name":"Étreinte"},{"id":59222682894710,"name":"À jamais"},{"id":59222682927478,"name":"Rendez-vous"}];
  const giftIds = new Set(variants.map(v => v.id));
  const end = Date.parse('2026-11-06T01:35:00+01:00');
  const root = (window.Shopify && window.Shopify.routes.root) || '/';
  let pending = null;
  let timer;
  let adding = false;
  let checkoutPass = false;
  const active = () => Date.now() < end;
  const post = async (path, data) => {
    const response = await fetch(root + path, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(data)});
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || result.message || 'Cart error');
    return result;
  };
  const refresh = () => {
    if (window.cart && typeof window.cart.getCart === 'function') window.cart.getCart();
    else window.location.assign(root + 'cart');
  };
  const config = () => document.querySelector('[data-rn-perfume-config]');
  const message = key => config()?.dataset[key] || '';
  const showError = (container, text) => {
    let error = container.querySelector('[data-rn-perfume-error]');
    if (!error) {
      error = document.createElement('p');
      error.dataset.rnPerfumeError = '';
      error.setAttribute('role','alert');
      container.appendChild(error);
    }
    error.textContent = text;
  };
  const choiceFor = item => {
    const props = item.properties || {};
    return variants.find(v => String(v.id) === String(props._rn_perfume_variant)) ||
      variants.find(v => Object.values(props).includes(v.name));
  };
  async function reconcile() {
    const response = await fetch(root + 'cart.js', {headers:{'Accept':'application/json'},cache:'no-store'});
    if (!response.ok) throw new Error('Cart unavailable');
    const cart = await response.json();
    const updates = {};
    const missing = [];
    for (const gift of cart.items.filter(i => giftIds.has(i.variant_id) && i.properties?._rn_perfume_offer === '1')) {
      const parent = cart.items.find(i => i.key === gift.parent_relationship?.parent_key);
      const choice = parent && choiceFor(parent);
      const wanted = active() && parent && eligible.has(parent.product_id) && choice?.id === gift.variant_id ? parent.quantity : 0;
      if (gift.quantity !== wanted) updates[gift.key] = wanted;
    }
    if (active()) {
      for (const parent of cart.items.filter(i => eligible.has(i.product_id))) {
        const choice = choiceFor(parent);
        if (!choice) continue;
        const gift = cart.items.find(i => i.variant_id === choice.id && i.parent_relationship?.parent_key === parent.key && i.properties?._rn_perfume_offer === '1');
        if (!gift) missing.push({id:choice.id,quantity:parent.quantity,parent_line_key:parent.key,properties:{_rn_perfume_offer:'1'}});
      }
    }
    if (Object.keys(updates).length) await post('cart/update.js',{updates});
    if (missing.length) await post('cart/add.js',{items:missing});
    const changed = Object.keys(updates).length || missing.length;
    if (changed) refresh();
    return changed;
  }
  const sync = () => {
    if (pending) return pending;
    pending = reconcile().finally(() => { pending = null; });
    return pending;
  };
  const schedule = () => {
    clearTimeout(timer);
    timer = setTimeout(() => { if (!adding) sync().catch(() => {}); },300);
  };
  async function add(form, button) {
    if (adding) return;
    const picker = form.querySelector('[data-rn-perfume]');
    const choice = form.querySelector('[data-rn-perfume-choice]:checked');
    if (!choice) return;
    if (!active()) { showError(picker,message('expired')); return; }
    adding = true;
    button?.setAttribute('aria-busy','true');
    picker.querySelector('[data-rn-perfume-error]')?.remove();
    try {
      if (pending) await pending;
      const data = new FormData(form);
      const properties = {};
      for (const [name,value] of data.entries()) {
        const match = name.match(/^properties\[(.+)\]$/);
        if (match && typeof value === 'string' && value) properties[match[1]] = value;
      }
      const fragrance = variants.find(v => v.name === choice.value);
      if (!fragrance) throw new Error('Invalid fragrance');
      properties._rn_perfume_variant = String(fragrance.id);
      const extras = [];
      const names = [];
      for (const box of form.querySelectorAll('[data-rn-variant]:checked')) {
        const id = box.getAttribute('data-rn-variant');
        const wrapper = form.querySelector('[data-rn-field-for="' + id + '"]');
        const field = wrapper?.querySelector('[data-rn-text]');
        const item = {id:Number(id),quantity:1};
        if (field && field.value.trim()) item.properties = {[field.getAttribute('data-rn-property')]:field.value.trim()};
        extras.push(item);
        names.push(box.getAttribute('data-rn-label'));
      }
      if (names.length) properties.Personnalisation = names.join(', ');
      const bouquet = {id:Number(data.get('id')),quantity:Math.max(1,parseInt(data.get('quantity'),10)||1),properties};
      if (data.get('selling_plan')) bouquet.selling_plan = data.get('selling_plan');
      const gift = {id:fragrance.id,quantity:bouquet.quantity,parent_id:bouquet.id,properties:{_rn_perfume_offer:'1'}};
      await post('cart/add.js',{items:extras.concat([bouquet,gift])});
      for (const box of form.querySelectorAll('[data-rn-variant]:checked')) {
        box.checked = false;
        box.dispatchEvent(new Event('change',{bubbles:true}));
      }
      refresh();
    } catch (error) {
      showError(picker,message('error'));
    } finally {
      adding = false;
      button?.removeAttribute('aria-busy');
    }
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[name="add"]');
    const form = button && (button.form || button.closest('form'));
    if (form?.querySelector('[data-rn-perfume-choice]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      add(form,button);
      return;
    }
    const checkout = event.target.closest('[name="checkout"],a[href="/checkout"],a[href$="/checkout"]');
    if (checkout && !checkoutPass && !checkout.disabled) {
      event.preventDefault();
      event.stopImmediatePropagation();
      sync().then(() => {
        checkoutPass = true;
        checkout.click();
        checkoutPass = false;
      }).catch(() => {
        const holder = checkout.closest('form') || checkout.parentElement;
        showError(holder,message('error'));
      });
    }
  },true);
  document.addEventListener('submit', event => {
    if (!event.target.querySelector('[data-rn-perfume-choice]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    add(event.target,event.submitter);
  },true);
  ['theme:cart:added','theme:cart:loaded','theme:cart:change','theme:cart:open'].forEach(name => document.addEventListener(name,schedule));
  document.addEventListener('shopify:section:load',schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',schedule);
  else schedule();
})();

